import { isMspAutoFeedToggleSupported } from "./mspe-product";

/** POC getMachineOverrideSignature — Off sends autoFedTypes:0 in calc body. */
export function mspOverrideSignature(
  productId: string,
  autoFeedOn: boolean,
): string {
  if (!isMspAutoFeedToggleSupported(productId)) return "";
  return autoFeedOn ? "" : "autoFedTypes:0";
}

export function mspModelConstantOverrides(
  productId: string,
  autoFeedOn: boolean,
): { autoFedTypes?: string } | undefined {
  if (!isMspAutoFeedToggleSupported(productId) || autoFeedOn) return undefined;
  return { autoFedTypes: "0" };
}
